import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Typography } from '@mui/material';

import { getAdvisorCodes, getAdvisors } from '../../../redux/providers/providers.slice';
import { setPageTitle } from '../../../redux/title/title.slice';
import Loader from '../../../components/ui/loader';

import { FTable, FTableCell } from '../../../components/ui/table';

export default function AdvisorCodes() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { advisors, advisorCodes, loadingAdvisorCodes } = useSelector((state) => state.providers);

  // Ensure advisors exist
  useEffect(() => {
    if (!advisors || advisors.length === 0) {
      dispatch(getAdvisors());
    }
  }, [dispatch, advisors]);

  // Fetch advisor codes
  useEffect(() => {
    if (id) {
      dispatch(getAdvisorCodes(id));
    }
  }, [dispatch, id]);

  // Find selected advisor
  const selectedAdvisor = useMemo(() => {
    return advisors?.find((a) => a.id === id || a.partnerId === id);
  }, [advisors, id]);

  const advisorName = selectedAdvisor
    ? `${selectedAdvisor.name1 || ''} ${selectedAdvisor.name2 || ''}`.trim()
    : 'Advisor';

  // Set page title
  useEffect(() => {
    dispatch(setPageTitle(advisorName));
  }, [dispatch, advisorName]);

  if (loadingAdvisorCodes) {
    return <Loader loading={true} message="Loading advisor codes..." />;
  }

  const columns = [{ label: 'Provider' }, { label: 'House Code' }, { label: 'Advisor Code' }];

  return (
    <FTable
      title={advisorName}
      columns={columns}
      rows={advisorCodes}
      emptyMessage="No codes found"
      renderRow={(code) => (
        <>
          <FTableCell>{code.providerName || '—'}</FTableCell>

          <FTableCell>{code.providerCode || '—'}</FTableCell>

          <FTableCell>{code.partnerCode || '—'}</FTableCell>
        </>
      )}
    />
  );
}
